var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-form-wrapper" },
    [
      _c("div", { on: { click: _vm.openPanel } }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c("div", { staticClass: "overlay-search" }, [
          _vm.open
            ? _c("div", { staticClass: "search-form-panel" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value,
                      expression: "value"
                    }
                  ],
                  ref: "search-value",
                  attrs: { type: "search", placeholder: _vm.i18n.searchOnSite },
                  domProps: { value: _vm.value },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.value = $event.target.value
                      },
                      _vm.search
                    ]
                  }
                }),
                _vm._v(" "),
                _vm.value
                  ? _c(
                      "ul",
                      { staticClass: "results" },
                      [
                        _vm.loading
                          ? _c(
                              "div",
                              { staticClass: "loading" },
                              [
                                _c("sync-loader", {
                                  staticClass: "spinner",
                                  attrs: { size: 10 }
                                })
                              ],
                              1
                            )
                          : _vm.results.length > 0
                          ? _vm._l(_vm.results, function(item) {
                              return _c("li", { key: item.id }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: item.url },
                                    domProps: { innerHTML: _vm._s(item.title) }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.title) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ])
                            })
                          : _vm.results.length === 0
                          ? _c("li", { staticClass: "no-results" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.i18n.noResult) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/danielescotti/htdocs/edilizia-acrobatica-wp/web/app/themes/edilizia-acrobatica-theme/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/Users/danielescotti/htdocs/edilizia-acrobatica-wp/web/app/themes/edilizia-acrobatica-theme/node_modules/vue-loader/lib??vue-loader-options!./scripts/components/SearchForm/SearchForm.vue?vue&type=template&id=c4c8703e&scoped=true&
// module id = 33
// module chunks = 0